/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDashboardTileRequest } from '../../models/create-dashboard-tile-request';
import { DashboardTileDto } from '../../models/dashboard-tile-dto';

export interface DashboardsDashboardIdTilesPost$Plain$Params {
  dashboardId: string;
      body?: CreateDashboardTileRequest
}

export function dashboardsDashboardIdTilesPost$Plain(http: HttpClient, rootUrl: string, params: DashboardsDashboardIdTilesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardTileDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardsDashboardIdTilesPost$Plain.PATH, 'post');
  if (params) {
    rb.path('dashboardId', params.dashboardId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DashboardTileDto>;
    })
  );
}

dashboardsDashboardIdTilesPost$Plain.PATH = '/dashboards/{dashboardId}/tiles';
